module.exports = __webpack_public_path__ + "static/media/01B.156d3e4d.png";